module.exports = __webpack_public_path__ + "static/img/hb_30-min.7b62de9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hb_30-min.png
// module id = GZ0Z
// module chunks = 1